// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"617b5bcc","239":"95f286f3","455":"06c2a7cb"}[chunkId] + ".chunk.js";
};